'use client';

import React, { useEffect } from 'react';

/**
 * INSTRUMENTACAO TEMPORARIA - remover apos identificar o erro em producao.
 * Captura erros de React Error Boundary no nivel da rota /
 */
export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('[app/error.tsx] ===== ERRO CAPTURADO PELO ERROR BOUNDARY =====');
    console.error('[app/error.tsx] message   :', error.message);
    console.error('[app/error.tsx] digest    :', error.digest);
    console.error('[app/error.tsx] stack     :', error.stack);
    console.error('[app/error.tsx] error obj :', error);
    console.error('[app/error.tsx] ============================================');
  }, [error]);

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <p style={{ color: '#666', fontSize: '0.875rem' }}>
        Ocorreu um erro inesperado. Por favor, recarregue a pagina.
      </p>
      <button
        onClick={reset}
        style={{ marginTop: '1rem', padding: '0.5rem 1rem', cursor: 'pointer' }}
      >
        Tentar novamente
      </button>
    </div>
  );
}
